module.exports = __webpack_public_path__ + "img/vip.f1ff7baf.png";